"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
// TypeScript has beaten me here 😔
// I admit, I have no idea how to overcome this enum merging
// and avoid typing the Record with "string"...
//
// export type MediaTypeIconNameRegistry = Record<MediaType, IconName>
//# sourceMappingURL=File.contracts.js.map